<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="200px">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="输入名称" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="消息标题" prop="title">
        <el-input v-model="form.title" placeholder="输入名称" :clearable="true"></el-input>
      </el-form-item>
      <!--  消息内容    -->

      <el-form-item label="消息类型">
        <el-radio-group v-model="form.contentType">
          <el-radio :label="0">文字</el-radio>
          <el-radio :label="1">语音</el-radio>
          <el-radio :label="2">图片</el-radio>
          <el-radio :label="3">视频</el-radio>
          <el-radio :label="4">跳转</el-radio>
          <el-radio :label="6">文件</el-radio>
        </el-radio-group>
      </el-form-item >
      <el-form-item   v-if="form.contentType === 4" label="消息卡片">
        <upload-img v-model="jumpContent.icon" :imgSize="1" :text="['图片大小5M以内', '图片格式png/jpg/gif']"></upload-img>
      </el-form-item>
      <el-form-item label="内容">
        <el-input v-if="form.contentType === 0"
            v-model="form.content"
            :autosize="{ minRows: 2, maxRows: 10}"
            type="textarea"
            placeholder="输入内容"
        />
        <uploadVideo   v-if="form.contentType === 3" v-model="form.content" :text="['视频大小500m以内', '视频格式mp4']"></uploadVideo>
        <upload-audio   v-if="form.contentType === 1" v-model="form.content" :text="['音频文件100M以内', '视频格式mp3']"></upload-audio>
        <upload-file  v-if="form.contentType === 6" v-model="form.content" :text="['文件大小1000M以内']"></upload-file>
        <upload-img v-if="form.contentType === 2" v-model="form.content" :imgSize="1" :text="['图片大小5M以内', '图片格式png/jpg/gif']"></upload-img>
        <jumpType2   v-if="form.contentType === 4" :Jumpurls="jumpContent"></jumpType2>
      </el-form-item>
      <el-form-item label="快捷菜单选项">
        <el-switch
            v-model="form.hasMenu"
            :active-value="1"
            :inactive-value="0"
            active-text="开启"
            inactive-text="关闭">
        </el-switch>
      </el-form-item>
      <el-form-item v-if="form.hasMenu == 1" label="可多选">
        <el-switch
            v-model="form.multipleChoice"
            :active-value="1"
            :inactive-value="0"
            active-text="开启"
            inactive-text="关闭">
        </el-switch>
      </el-form-item>
      <el-form-item v-if="form.hasMenu == 1">
        <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
          <div
              style="text-align: center;color: #909399;width: 99%;margin: 2px auto;margin-bottom: 24px; "
          >菜单选项</div>
          <div  v-for="(item, index) in form.choiceList" :key="index">
            <el-alert :title=" 'NO.' + (index + 1) + ' ' + item.name" style="margin: 10px;" type="info" :closable="false" />
            <el-form label-width="200px" size="small">
              <el-form-item label="选项名称" prop="name">
                <el-input v-model="item.name" placeholder="输入名称" :clearable="true"></el-input>
              </el-form-item>
              <el-form-item label="触发动作">
                <el-radio-group v-model="item.businessType">
                  <el-radio :label="0">回复内容</el-radio>
                  <el-radio :label="1">人工服务</el-radio>
                  <el-radio :label="2">开始任务</el-radio>
                  <el-radio :label="3">开始问卷</el-radio>
                  <el-radio :label="4">内容合集</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="动作内容">
                <el-select
                    v-if="item.businessType == 0"
                    v-model="item.businessId"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="搜素回复"
                    :remote-method="getReplyList"
                    :loading="replyOptionLoading"
                >
                  <el-option
                      v-for="option in replyList"
                      :key="option.key"
                      :label="option.value"
                      :value="option.key"
                  />
                </el-select>
                <el-select
                    v-if="item.businessType == 2"
                    v-model="item.businessId"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="搜素任务"
                    :remote-method="getClockInList"
                    :loading="replyOptionLoading"
                >
                  <el-option
                      v-for="option in clockInList"
                      :key="option.key"
                      :label="option.value"
                      :value="option.key"
                  />
                </el-select>
                <el-select
                    v-if="item.businessType == 3"
                    v-model="item.businessId"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="搜素问卷"
                    :remote-method="getQuestionnaireList"
                    :loading="replyOptionLoading"
                >
                  <el-option
                      v-for="option in questionnaireList"
                      :key="option.key"
                      :label="option.value"
                      :value="option.key"
                  />
                </el-select>
                <el-select
                    v-if="item.businessType == 4"
                    v-model="item.businessId"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="搜素关键词"
                    :remote-method="getKeywordList"
                    :loading="replyOptionLoading"
                >
                  <el-option
                      v-for="option in keywordList"
                      :key="option.key"
                      :label="option.value"
                      :value="option.key"
                  />
                </el-select>
              </el-form-item>
              <el-form-item>
                <div style="display: flex;justify-content: center;margin-top: 14px;">
                  <el-button
                      type="danger"
                      size="mini"
                      @click="removeList(index)"
                      v-if="index !== 0"
                  >-删除回复</el-button>
                </div>
              </el-form-item>
            </el-form>

          </div>
          <div style="display: flex;justify-content: center;margin-bottom: 14px;margin-top: 14px;">
            <el-button type="primary" size="mini" @click="addList">+增加回复</el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="$router.back()">取 消</el-button>
      <el-button type="success" @click="confirm('form')">确定</el-button>
    </div>
  </d2-container>
</template>
<script>
import {
  addContent,
  updateContent,
  getContentInfo,
  replyContentOption,
  replyKeywordOption,
  questionnaireOption
} from '@/api/demo/helper/index'
import {
  getClockInOptions
} from '@/api/demo/punchInActivity/index'
import { getPosterList } from '@/api/demo/poster/index'
import { getToken } from '@/api/demo/classification/index'
import uploadVideo from '@/components/uploadVideo/index.vue'
import uploadAudio from '@/components/uploadAudio/index.vue'
import UploadImg from '@/components/uploadImage/index.vue'
import jumpType2 from '@/components/jumpType/jumpType'
import uploadFile from '@/components/uploadFile/index.vue'
export default {
  components: {
    jumpType2,
    uploadVideo,
    uploadFile,
    uploadAudio,
    UploadImg
  },
  name: 'editHelperContent',
  data () {
    return {
      jumpContent: {
        url: null,
        id: null,
        classId: null,
        paramType: '0',
        value: '',
        icon: ''
      },
      replyList: [],
      keywordList: [],
      questionnaireList: [],
      clockInList: [],
      id: '', // id
      form: {
        keyword: '', // 关键字
        name: '', // 活动名称
        title: '',
        contentType: 0,
        hasMenu: 0,
        multipleChoice: 0,
        content: '',
        choiceList: [ // 菜单选项
          {
            id: '',
            businessId: '',
            name: '',
            businessType: 0
          }
        ]
      },
      replyOptionLoading: false,
      rules: {
        keyword: [
          {
            required: true,
            message: '请输入关键词',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 50,
            message: '长度在 1 到 50 个字符',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    let that = this
    that.id = that.$route.query.id
    if (that.id != null) {
      that.getInfo(that.id)
    }
    that.getClockInList()
    that.getReplyList()
    that.getKeywordList()
    that.getQuestionnaireList()
  },
  methods: {
    removeList (index) {
      this.form.choiceList.splice(index, 1)
      this.form.choiceList.forEach((item, index) => {
        item.index = index
      })
    },
    addList () {
      this.form.choiceList.push({
        businessId: 0
      })
    },
    getQuestionnaireList (keyword) {
      let that = this
      let query = { 'keyword': keyword }
      that.replyOptionLoading = true
      questionnaireOption(query).then(res => {
        that.questionnaireList = res
      }).finally(() => {
        that.replyOptionLoading = false
      })
    },
    getReplyList (keyword) {
      let that = this
      let query = { 'keyword': keyword }
      that.replyOptionLoading = true
      replyContentOption(query).then(res => {
        that.replyList = res
      }).finally(() => {
        that.replyOptionLoading = false
      })
    },
    getKeywordList (keyword) {
      let that = this
      let query = { 'keyword': keyword }
      that.replyOptionLoading = true
      replyKeywordOption(query).then(res => {
        that.keywordList = res
      }).finally(() => {
        that.replyOptionLoading = false
      })
    },
    getClockInList (keyword) {
      let that = this
      let query = { 'keyword': keyword }
      that.replyOptionLoading = true
      getClockInOptions(query).then(res => {
        that.clockInList = res
      }).finally(() => {
        that.replyOptionLoading = false
      })
    },
    getInfo (id) {
      let that = this
      getContentInfo(id).then(res => {
        if (res.contentType == 4) {
          that.jumpContent = JSON.parse(res.content)
        }
        that.form = res
      })
    },
    confirm () {
      if (this.form.contentType == 4) {
        this.form.content = JSON.stringify(this.jumpContent)
      }
      if (this.id) {
        this.getModify('form')
      } else {
        this.getCreate('form')
      }
    },
    // 新增
    getCreate (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        addContent(that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '新增成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
        })
      })
    },
    // 编辑
    getModify (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        updateContent(that.id, that.form).then(res => {
          that.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
            duration: 2000
          })
          that.$router.back()
        })
      })
    }
  },
  mounted () {
  }
}
</script>
<style scoped>
/deep/.el-input-number {
  margin-right: 12px;
}
.footer {
  text-align: center;
  margin-top: 20px;
}
</style>
